module.exports = __webpack_public_path__ + "static/media/201.8ffb2056.webp";